module.exports = __webpack_public_path__ + "img/UNION2x.png?375468906e9be4e635a0209a6987dc2b";